import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=011d7d12&scoped=true"
import script from "./CalendarItem.vue?vue&type=script&lang=js"
export * from "./CalendarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011d7d12",
  null
  
)

export default component.exports